module.exports = __webpack_public_path__ + "img/alex-cubes.1604af71.svg";